import { useEffect, useState } from "react";
import { blackfeoVisivel } from "@/lib/black-november/ofertas-lps";

const KEY = "feo-blackfeo-preview";

/** Prévia: ?preview=1 vale para a visita inteira (sessão do navegador). */
export function lerPreviewBlackfeo(): boolean {
  try {
    if (new URLSearchParams(window.location.search).get("preview") === "1") {
      sessionStorage.setItem(KEY, "1");
      return true;
    }
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/** true quando a BLACKFEO deve aparecer (estável na hidratação e vira sozinho às 00h de 04/11). */
export function useBlackfeo(): boolean {
  const [ativa, setAtiva] = useState(false);
  useEffect(() => {
    const preview = lerPreviewBlackfeo();
    const update = () => setAtiva(blackfeoVisivel(Date.now(), preview));
    update();
    const t = window.setInterval(update, 15_000);
    return () => window.clearInterval(t);
  }, []);
  return ativa;
}
